angular.module('rjmNg.constants').constant('conversionConstants'
  TIME_CONVERSIONS: Object.freeze
    secondsPerMin: 60
    secondsPerHour: 3600
    secondsPerDay: 86400
    secondsPerMonth: 2629800
    secondsPerYear: 31557600

  DIGITAL_SIZE_CONVERSIONS: Object.freeze
    bytesPerKilobyte: 1024
    bytesPerMegabyte: 1048576
    bytesPerGigabyte: 1073741824
    bytesPerTerabyte: 1099511627776
)
